export const IconConfirmationCheckMark: {
  name: 'icon_confirmation_check_mark-f81cc4abaff6'
} = {
  name: 'icon_confirmation_check_mark-f81cc4abaff6'
}
